<template>
  <div class="attendance-scheduling-rank-detail">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />

    <div style="display: flex;justify-content: space-between;align-items: center;">
      <div class="attendance-scheduling-rank-detail-sub">
        <div style="margin-right: 10px;">日期选择</div>
        <el-date-picker v-model="schedulingMonth" type="month" format='yyyy-MM' value-format="yyyy-MM" size="small" style="width: 280px" placeholder="排班日期"></el-date-picker>
      </div>
      <div style="display: flex;justify-content: flex-end;align-items: center;">
        <download-excel
          class="btn btn-default"
          :header="json_header"
          :data="json_data"
          :fields="json_fields"
          :worksheet="excelName"
          type="xls"
          :name="excelName">
          <button-cancel value="导出" />
        </download-excel>
        <button-cancel @cancel="cancel" value="返回" style="margin-left: 10px;" />
      </div>
    </div>

    <div class="attendance-scheduling-rank-detail-table">
      <div class="attendance-scheduling-rank-detail-table-head">
        <div class="attendance-scheduling-rank-detail-table-item-department">部门</div>
        <div class="attendance-scheduling-rank-detail-table-item-position">岗位</div>
        <div class="attendance-scheduling-rank-detail-table-item-groupname">班组</div>
        <div class="attendance-scheduling-rank-detail-table-item-name">姓名</div>
        <div class="attendance-scheduling-rank-detail-table-item-day" v-for="day in dayInSchedulingMonthArr">
          <div class="attendance-scheduling-rank-detail-table-item-day-week-tip">{{day.weekDay}}</div>
          <div>{{day.day}}</div>
        </div>
      </div>
      <div style="flex: 1;overflow-y: auto;">
        <div class="attendance-scheduling-rank-detail-table-info" v-for="personInfo in schedulingTableData">
          <div class="attendance-scheduling-rank-detail-table-item-department" :title="personInfo.person.deptName">{{ personInfo.person.deptName }}</div>
          <div class="attendance-scheduling-rank-detail-table-item-position" :title="personInfo.person.position">{{ personInfo.person.position }}</div>
          <div class="attendance-scheduling-rank-detail-table-item-groupname" :title="personInfo.person.groupName">{{personInfo.person.groupName}}</div>
          <div class="attendance-scheduling-rank-detail-table-item-name" :title="personInfo.person.name">{{personInfo.person.name}}</div>
          <div class="attendance-scheduling-rank-detail-table-item-day" :title="personInfo.person.classesName" v-for="schedules in personInfo.schedules">{{schedules.classesName}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import {bus} from '../../../utils/bus'
  import {api} from '../../api/AttendancePoint'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'attendance-scheduling-rank-detail',
    data () {
      return {
        breadcrumb: [{
          value: '智慧考勤',
          name: 'attendance-department-manage'
        }, {
          value: '排班管理'
        }],
        mainTitle: '排班记录',
        subheading: '',

        classesList: [],
        classesSelectList: [],
        schedulingMonth: '',
        dayInSchedulingMonthArr: [],
        formData: {
          groupCode: '',
          classesCodes: ''
        },
        schedulingTableData: [],

        json_header: '考勤排班表',
        json_fields: {},
        json_data: [],
        json_meta: [
          [
            {
              'key': 'charset',
              'value': 'utf-8'
            }
          ]
        ],
        excelName: '考勤排班表.xls'
      }
    },
    created () {
      this.getCurrentMonthInfo()
    },
    methods: {
      // 查询当月信息
      getCurrentMonthInfo () {
        let nowDate = new Date()
        let year = nowDate.getFullYear()
        let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
        this.schedulingMonth = `${year}-${month}`
        this.getAllDayInSchedulingMonth()
      },

      // 获取某月的天数及每日星期
      getAllDayInSchedulingMonth () {
        let year = this.schedulingMonth.split('-')[0]
        let month = this.schedulingMonth.split('-')[1]
        let dayNum = (new Date(year, month, 0)).getDate()
        let presentDate = new Date(`${this.schedulingMonth}-01`)
        let today = presentDate.getDay() !== 0 ? presentDate.getDay() : 7
        let weekArr = ['日', '一', '二', '三', '四', '五', '六'], dayInSchedulingMonthArr = []
        let json_fields = {
          '部门': 'deptName',
          '岗位': 'position',
          '班组': 'groupName',
          '姓名': 'name',
        }
        for (let i = 1; i <= dayNum; i++) {
          let weekIndex = (i + today - 1) % 7
          let obj = {
            day: i,
            weekDay: weekArr[weekIndex]
          }
          json_fields[`${i} (周${weekArr[weekIndex]})`] = `attendance${i}`
          dayInSchedulingMonthArr.push(obj)
        }
        this.dayInSchedulingMonthArr = dayInSchedulingMonthArr
        this.json_header = `${year}-${month}考勤排班表`
        this.excelName = `${year}-${month}考勤排班表.xls`
        this.json_fields = json_fields
      },

      // 查询排班信息
      getAttendanceScheduleAll () {
        this.$axios.post(`${api.getAttendanceScheduleAll}`, {
          groupCode: this.formData.groupCode,
          startTime: `${this.schedulingMonth}-01`
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              let schedulingTableData = data.table
              let json_data = []
              schedulingTableData.map(v => {
                let json_data_item = {name: v.person.name, deptName: v.person.deptName, position: v.person.position, groupName: v.person.groupName}
                v.schedules.map((item, index) => {
                  item.selectCode = item.classesCode
                  item.defaultSelectCode = item.classesCode
                  let keyName = `attendance${index + 1}`
                  json_data_item[keyName] = item.classesName
                })
                json_data.push(json_data_item)
              })
              this.schedulingTableData = data.table
              this.json_data = json_data
            }
          })
          .catch(errorHandler('查询失败'))
      },

      schedulesItemchange (e) {
        this.schedulingTableData.map(v => {
          v.schedules.map(info => {
            if (info.selectCode !== info.defaultSelectCode) {
              info.isModifyState = true
            }
          })
        })
      },

      personSelectCodeChange () {
        this.schedulingTableData.map(v => {
          if (v.personSelectCode) {
            v.schedules.map(info => {
              info.selectCode = v.personSelectCode
              if (info.selectCode !== info.defaultSelectCode) {
                info.isModifyState = true
              }
              this.classesSelectList.map((classItem, classIndex) => {
                if (info.selectCode === classItem.classesCode) {
                  info.className = `attendance-scheduling-rank-detail-table-item-select-${classIndex}`
                }
              })
            })
            v.personSelectCode = ''
          }
        })
      },

      toManagementPage () {
        this.$router.push({
          name: 'attendance-scheduling-manage'
        })
      },

      cancel () {
        this.toManagementPage()
      }
    },
    watch: {
      schedulingMonth (v) {
        if (this.schedulingMonth) {
          this.getAllDayInSchedulingMonth()
          this.getAttendanceScheduleAll()
        } else {
          nError('请选择日期')
        }
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 190px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 600px;
    padding: 0 140px;
    margin: 40px auto;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
.attendance-scheduling-rank-detail {
  font-family: Source Han Sans SC;
  .attendance-scheduling-rank-detail-sub {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    min-height: 24px;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: #333333;
    text-align: left;
    margin: 20px 0 10px 0;
  }
  .attendance-scheduling-rank-detail-info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .attendance-scheduling-rank-detail-table {
    text-align: center;
    width: 100%;
    height: 486px;
    margin-top: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 8px rgba(92, 92, 92, 0.16);
    border-radius: 7px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    ::-webkit-scrollbar {
      width: 2px;
      height: 1px;
    }
    .el-select, .el-select>.el-input {
      height: 100%;
    }
    .el-input--suffix .el-input__inner {
      width: 100%;
      height: 100%;
      padding: 0;
      font-size: 12px;
      border: 0;
      border-radius: 0;
      text-align: center;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .el-input__suffix {
      display: none;
    }
    .attendance-scheduling-rank-detail-table-head, .attendance-scheduling-rank-detail-table-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eeeeee;
      .attendance-scheduling-rank-detail-table-item-department, .attendance-scheduling-rank-detail-table-item-position, .attendance-scheduling-rank-detail-table-item-groupname, .attendance-scheduling-rank-detail-table-item-name {
        width: 80px;
        height: 48px;
        font-size: 14px;
        font-weight: 400;
        line-height: 48px;
        color: #333333;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        border-right: 1px solid #eeeeee;
      }
      .attendance-scheduling-rank-detail-table-item-day {
        width: 28px;
        padding: 5px 0;
        flex: 1;
        border-right: 1px solid #eeeeee;
        .attendance-scheduling-rank-detail-table-item-day-week-tip {
          font-size: 12px;
          color: #CCCCCC;
          margin-bottom: 7px;
        }
      }
      .attendance-scheduling-rank-detail-table-item-day:last-child {
        border-left: 0;
      }
    }
    .attendance-scheduling-rank-detail-table-info {
      .attendance-scheduling-rank-detail-table-item-day {
        display: flex;
        align-items: center;
        font-size: 12px;
        padding: 0;
        height: 48px;
      }
      .attendance-scheduling-rank-detail-table-item-select-1 {
        .el-input--suffix .el-input__inner {
          background: #C4D8FF;
          color: #FFFFFF;
        }
      }
      .attendance-scheduling-rank-detail-table-item-select-2 {
        .el-input--suffix .el-input__inner {
          background: #FED195;
          color: #FFFFFF;
        }
      }
      .attendance-scheduling-rank-detail-table-item-select-3 {
        .el-input--suffix .el-input__inner {
          background: #C593FF;
          color: #FFFFFF;
        }
      }
      .attendance-scheduling-rank-detail-table-item-select-4 {
        .el-input--suffix .el-input__inner {
          background: #FF9A8D;
          color: #FFFFFF;
        }
      }
    }
  }
  .el-switch {
    height: 30px;
  }
  .classes-list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    .classes-item {
      width: 150px;
      height: 78px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
      margin-right: 20px;
      .classes-item-box {
        width: 38px;
        height: 38px;
      }
      .classes-item-text {
        color: #333333;
        font-size: 12px;
        height: 20px;
        line-height: 20px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/view/WorkAttendance/AttendanceScheduling/AttendanceSchedulingRankDetail.vue